<template>
  <div>
    <base-header class="pb-9" type="danger"> </base-header>
    <div class="container-fluid mt--8">
      <!-- <div class="row">
        <div class="col">
          <div class="card shadow">
            <div class="card-header">
              <div class="h3 mb-0">Query</div>
            </div>
            <div class="card-body mb--4">
              <div class="row align-items-center">
               
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="row">
        <div class="col">
          <div class="card mb-4 mt-3">
            <h3 class="card-header mb-0">Clip Queue</h3>
            <ul v-if="requests.length" class="list-group list-group-flush list">
              <li
                v-for="clip in requests"
                class="list-group-item px-0"
                :key="clip.id"
              >
                <div class="container">
                  <div class="row">
                    <div class="col">
                      {{ clip.status }}
                      <div v-if="clip.status === 'processing' && clip.progress" class="mt-1">
                        <div class="clip-progress">
                          <div
                            class="clip-progress-fill"
                            :style="{ width: progressPercent(clip) + '%' }"
                          ></div>
                        </div>
                        <small>
                          {{ progressPercent(clip) }}%<span v-if="clip.progress.timemark"> ({{ clip.progress.timemark }})</span>
                        </small>
                      </div>
                    </div>
                                   <div class="col">
                  {{ clip.event.bookmark }}
                                   </div>
                                              <div class="col">
               <span v-if="clip.duration">Duration: {{ Math.round(clip.duration) }}s</span>
                                   </div>
                    <div class="col">
                      {{ clip.event.username }}
                    </div>

                    <div class="col">{{ clip.created_at | dateAndTime }}</div>
                    <div class="col">
                      <a
                        :href="`/#/recording/${clip.file}/${clip.event.id}`"
                        >Go to</a
                      >
                   
                    </div>
                    <div class="col-2">
                      <base-button
                        block
                        type="danger"
                        v-if="clip.status === 'requested'"
                        size="sm"
                        @click="cancel(clip.id, clip.event.id)"
                        >Cancel</base-button
                      >
                      <base-button
                        block
                        type="primary"
                        v-else-if="canReRequest(clip)"
                        size="sm"
                        @click="reRequest(clip)"
                        >Re-request</base-button
                      >
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div v-else class="card-body text-center text-muted py-5">
              No recent requests
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArchiveClip from "./Components/ArchiveClip.vue";
export default {
  data() {
    return {};
  },
  components: {
    // reels: ReelsExpander,
    'archive-clip': ArchiveClip,
  },
  computed: {
    requests() {
      const list = this.$store.getters["clippingRequests/array"] || [];
      return [...list].sort((a, b) => this.requestCreatedAtMs(b) - this.requestCreatedAtMs(a));
    },
    config() {
      return this.$store.getters["config/config"];
    },
    loading() {
      return this.$store.getters["user/loading"];
    },
    user() {
      return this.$store.getters["user/user"];
    },
    matches() {
      return this.$store.getters["matches/array"];
    },
    matchFormats() {
      return this.$store.getters["matchFormats/formats"];
    },
    matchTypes() {
      return this.$store.getters["matchFormats/types"];
    },
    filterOptionArray() {
      return Object.values(this.filterOptions);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.matches.length;
    },
  },
  beforeMount() {
    const liveWindowHours = 72;
    const cutoff = new Date(Date.now() - liveWindowHours * 60 * 60 * 1000);
    const where = [["created_at", ">=", cutoff]];
    const orderBy = ["created_at", "desc"];
    this.$store.dispatch("clippingRequests/openDBChannel", {
        clauses: { where, orderBy },
      })
      .catch(console.error);
  },
  beforeDestroy() {
    this.$store.dispatch("clippingRequests/closeDBChannel");
  },

  methods: {
    requestCreatedAtMs(request) {
      if (!request || !request.created_at) return 0;
      if (request.created_at.seconds) return request.created_at.seconds * 1000;
      const dt = new Date(request.created_at);
      const ms = dt.getTime();
      return Number.isFinite(ms) ? ms : 0;
    },
    remove(id) {
      this.$store.dispatch("clippingRequests/delete",
       id
      );
    },
    cancel(id, eventId) {
      this.$store.dispatch("archiveEvents/patch", {
        id: eventId,
        clipStatus: "cancelled",
      });
      this.$store.dispatch("clippingRequests/patch", {
        id: id,
        status: "cancelled",
      });
    },
    canReRequest(clip) {
      return (
        clip &&
        clip.id &&
        clip.event &&
        clip.event.id &&
        clip.status !== "requested" &&
        clip.status !== "complete"
      );
    },
    reRequest(clip) {
      this.$store.dispatch("archiveEvents/patch", {
        id: clip.event.id,
        clipStatus: "clipping",
      });
      const retryPayload = {
        ...clip,
      };
      delete retryPayload.id;
      delete retryPayload.created_at;
      delete retryPayload.updated_at;
      delete retryPayload.completed_at;
      delete retryPayload.failed_at;
      delete retryPayload.processing_started_at;
      delete retryPayload.lastAttemptAt;
      delete retryPayload.nextRetryAt;
      delete retryPayload.retryRequestedAt;
      delete retryPayload.errorCode;
      delete retryPayload.errorDetail;
      delete retryPayload.error_message;
      delete retryPayload.duration;
      delete retryPayload.clipFile;
      delete retryPayload.effectiveEncode;
      delete retryPayload.requestId;
      delete retryPayload.documentPath;
      delete retryPayload.eventId;
      delete retryPayload.attempt;
      delete retryPayload.retriedFrom;

      retryPayload.status = "requested";
      retryPayload.retriedFrom = clip.id;
      retryPayload.attempt = 0;

      this.$store.dispatch("clippingRequests/insert", retryPayload);
      this.$store.dispatch("clippingRequests/patch", {
        id: clip.id,
        status: "superseded",
        supersededByRetry: true,
      });
    },
    progressPercent(clip) {
      if (!clip || !clip.progress) return 0;
      const value = Number(clip.progress.percent);
      if (!Number.isFinite(value)) return 0;
      return Math.max(0, Math.min(100, Math.round(value)));
    },
  },
};
</script>

<style >
.el-table__expand-column {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.card .el-table td,
.card .el-table th {
  padding-left: 0.7rem;
  padding-right: 0.7rem;
}
.select-danger .el-select .el-tag {
  background: #f5365c;
}

.clip-progress {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  background: #e9ecef;
  overflow: hidden;
}

.clip-progress-fill {
  height: 100%;
  background: #5e72e4;
  transition: width 0.3s ease;
}
</style>